export class NotFoundError extends Error {}
export class MintPaused extends Error {}
